module.exports = __webpack_public_path__ + "static/downloable/formato-solicitud-pago-de-renta-de-sobrevivencia.eb871ab.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloable/formatos/formato-solicitud-pago-de-renta-de-sobrevivencia.pdf
// module id = W/NU
// module chunks = 1